import React, { useEffect, useRef, useState } from 'react';
import { getPaymentCards, bindPaymentCard, getPaymentCardStatus, removePaymentCard } from '../api';
import { getCustomer } from '../services/customerService';

export default function CustomerPaymentMethods() {
  const [data, setData] = useState(null), [error, setError] = useState(''), [consent, setConsent] = useState(false), [busy, setBusy] = useState(false), [refresh, setRefresh] = useState(0);
  const action = useRef(false), polls = useRef(0);
  const bindingKey = 'maxmarket.card-binding:' + (getCustomer()?.phone || '');
  useEffect(() => {
    let active = true, timer;
    getPaymentCards().then(async ({ data: value }) => {
      if (!active) return;
      setData(value);
      try { const requestId = sessionStorage.getItem(bindingKey); if (value.cards.some(card => card.id === requestId && card.status === 'CONFIRMED')) sessionStorage.removeItem(bindingKey); } catch { /* Server card state remains authoritative. */ }
      const pending = value.cards.filter(card => ['WAITING', 'UNKNOWN', 'STARTING'].includes(card.status));
      if (pending.length && polls.current++ < 30) {
        await Promise.allSettled(pending.map(card => getPaymentCardStatus(card.id)));
        if (active) timer = setTimeout(() => setRefresh(n => n + 1), 5000);
      }
    }).catch(e => { if (active) setError(e.response?.data?.error || 'Не удалось загрузить способы оплаты'); });
    return () => { active = false; clearTimeout(timer); };
  }, [refresh, bindingKey]);
  const bind = async () => {
    if (!consent || action.current) return;
    action.current = true; setBusy(true); setError('');
    try {
      let requestId = sessionStorage.getItem(bindingKey);
      const old = data?.cards.find(card => card.id === requestId);
      if (!requestId || ['CONFIRMED', 'FAILED', 'DISABLED'].includes(old?.status)) { requestId = crypto.randomUUID(); sessionStorage.setItem(bindingKey, requestId); }
      const { data: card } = await bindPaymentCard(requestId, true);
      if (card.bindingUrl) window.location.assign(card.bindingUrl);
      else { setRefresh(n => n + 1); setConsent(false); }
    } catch (e) { setError(e.response?.data?.error || 'Ответ не получен. Проверьте существующую привязку перед новой попыткой.'); setRefresh(n => n + 1); }
    finally { action.current = false; setBusy(false); }
  };
  const remove = async id => {
    if (action.current || !window.confirm('Отвязать карту? Для следующих оплат нужно будет выбрать другой способ.')) return;
    action.current = true; setBusy(true); setError('');
    try { await removePaymentCard(id); if (sessionStorage.getItem(bindingKey) === id) sessionStorage.removeItem(bindingKey); setRefresh(n => n + 1); }
    catch (e) { setError(e.response?.data?.error || 'Не удалось отвязать карту'); }
    finally { action.current = false; setBusy(false); }
  };
  return <section className="checkout-card" aria-labelledby="payment-methods-title">
    <h2 id="payment-methods-title">Способы оплаты</h2>
    <p>Привяжите карту в защищённой форме банка. Оплата заказа выполняется только после нажатия «Оплатить».</p>
    {error && <p role="alert" className="profile-error">{error}</p>}
    {!data && <p role="status">Загружаем способы оплаты…</p>}
    {data?.cards.map(card => <div className="checkout-card" key={card.id}>
      <strong>{card.lastFour ? `Карта •••• ${card.lastFour}` : 'Привязка карты'}</strong>
      <p>{card.status === 'CONFIRMED' ? 'Карта привязана' : card.status === 'FAILED' ? 'Банк не подтвердил привязку' : 'Ожидаем подтверждения банка'}</p>
      {card.bindingUrl && <a className="btn btn-outline" href={card.bindingUrl}>Продолжить привязку в банке</a>}
      <button type="button" className="customer-login-link" disabled={busy} onClick={() => remove(card.id)}>Отвязать</button>
    </div>)}
    {data && !data.enabled ? <p role="status">{data.message}</p> : data && <>
      <label className="pickup-point-card"><input type="checkbox" checked={consent} onChange={event => setConsent(event.target.checked)} disabled={busy} /><span>Согласен сохранить карту для моих последующих оплат по кнопке «Оплатить». Банк может запросить подтверждение карты; привязка не оплачивает товар.</span></label>
      <button type="button" className="profile-btn" disabled={!consent || busy} onClick={bind}>{busy ? 'Открываем банк…' : 'Привязать карту'}</button>
    </>}
    <button type="button" className="customer-login-link" disabled={busy} onClick={() => { polls.current = 0; setRefresh(n => n + 1); }}>Проверить статус карт</button>
  </section>;
}
